var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnteriorBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 2048",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "abdominals"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M ... Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "chest"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M ... Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shoulders-anterior"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M ... Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "quadriceps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M ... Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnteriorBody);
export default __webpack_public_path__ + "static/media/anterior-body.3888e8f8d41ebcef85fc269dfd7d7c02.svg";
export { ForwardRef as ReactComponent };